import React, { useEffect } from "react"
import { useScheduledTaskReportExportContext } from "contexts/ScheduledTaskReportExportContext"
import {
  DAILY,
  WEEKLY,
  MONTHLY,
} from "utils/recurrenceDetailsHelpers"
import {
  DAYS, MONTHS, WEEKS,
} from "utils/dateHelpers"
import queryParameter from "utils/queryParameter"
import DetailFields from "shared/ScheduledReportExport/DetailFields"

const RANGE_UNIT_BY_FREQUENCY = {}
RANGE_UNIT_BY_FREQUENCY[DAILY] = DAYS
RANGE_UNIT_BY_FREQUENCY[WEEKLY] = WEEKS
RANGE_UNIT_BY_FREQUENCY[MONTHLY] = MONTHS

const NAME_PARAM = "name"
const REPORT_FREQUENCY_PARAM = "frequency"

const unitByFrequency = (frequency) => RANGE_UNIT_BY_FREQUENCY[frequency]

const ScheduledTaskReportExportDetailFields = () => {
  const {
    frequency,
    recurrenceDayOfMonth,
    recurrenceDayOfWeek,
    setReportFrequency,
    setRecurrenceDayOfMonth,
    setRecurrenceDayOfWeek,
    setScheduledReportExportName,
    setStartDate,
    setTaskPreviousRangeUnit,
    scheduledReportExportName,
    startDate,
  } = useScheduledTaskReportExportContext()

  // The name and frequency are chosen in the modal on the reports index and arrive as query params.
  // On the edit page they are absent, so the hydrated values are left alone.
  useEffect(() => {
    if (queryParameter(NAME_PARAM)) {
      setScheduledReportExportName(queryParameter(NAME_PARAM))
    }

    if (queryParameter(REPORT_FREQUENCY_PARAM)) {
      setReportFrequency(queryParameter(REPORT_FREQUENCY_PARAM))
      setTaskPreviousRangeUnit(unitByFrequency(queryParameter(REPORT_FREQUENCY_PARAM)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DetailFields
      frequency={frequency}
      recurrenceDayOfMonth={recurrenceDayOfMonth}
      recurrenceDayOfWeek={recurrenceDayOfWeek}
      setRecurrenceDayOfMonth={setRecurrenceDayOfMonth}
      setRecurrenceDayOfWeek={setRecurrenceDayOfWeek}
      setScheduledReportExportName={setScheduledReportExportName}
      setStartDate={setStartDate}
      scheduledReportExportName={scheduledReportExportName}
      startDate={startDate}
    />
  )
}

export default ScheduledTaskReportExportDetailFields
